import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const partnerApi = axios.create({ baseURL: API });

partnerApi.interceptors.request.use((config) => {
  const t = localStorage.getItem("hp_token");
  if (t) config.headers.Authorization = `Bearer ${t}`;
  return config;
});

export default partnerApi;
